import React from 'react';
import styled from 'styled-components';

const Support = () => {
return (
<BodyWrap>
    <Nav>
        <div className="nav-content">UST PEST SERVICE Support</div>
    </Nav>

    <Container>
        <h1>Contact Us</h1>
        <p className="intro">How can we help you today?</p>

        <FormCard>
            {/* 구글 폼 액션 주소와 메서드 유지 */}
            <form
              action="https://docs.google.com/forms/d/e/1FAIpQLScq9SHLTYU8JYy7EIZ4uPNx0cDPZCHebgZyO50S5a9d5R6h1g/formResponse"
              method="POST"
            >
                <InputGroup>
                    <label htmlFor="email">Email Address</label>
                    <input
                      id="email"
                      type="email"
                      name="entry.495725345"
                      placeholder="email@example.com"
                      required
                    />
                </InputGroup>

                <InputGroup>
                    <label htmlFor="message">Message</label>
                    <textarea
                      id="message"
                      name="entry.1736814242"
                      rows="5"
                      placeholder="Please describe your enquiry"
                      required
                    />
                </InputGroup>

                <SubmitBtn type="submit">Send Message</SubmitBtn>
                <p className="note">You will be redirected to a Google confirmation page after submission.</p>
            </form>
        </FormCard>

        <Footer>
            &copy; 2026 MKB Global Service Private Inc. All rights reserved.
        </Footer>
    </Container>
</BodyWrap>
);
};

export default Support;

/* Styled Components */

const BodyWrap = styled.div`
margin: 0;
font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
background: #f5f5f7;
color: #1d1d1f;
line-height: 1.6;
min-height: 100vh;
`;

const Nav = styled.nav`
height: 44px;
background: rgba(255, 255, 255, 0.8);
backdrop-filter: blur(20px);
display: flex;
align-items: center;
border-bottom: 1px solid #d2d2d7;
position: sticky;
top: 0;
z-index: 100;

.nav-content {
max-width: 600px;
margin: 0 auto;
width: 100%;
padding: 0 20px;
font-weight: 600;
}
`;

const Container = styled.main`
max-width: 600px;
margin: 0 auto;
padding: 60px 20px;

h1 {
font-size: 40px;
font-weight: 700;
text-align: center;
margin-bottom: 10px;
letter-spacing: -0.015em;
}

.intro {
text-align: center;
color: #86868b;
margin-bottom: 40px;
font-size: 19px;
}
`;

const FormCard = styled.div`
background: #fff;
padding: 40px;
border-radius: 20px;
box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);

.note {
font-size: 12px;
color: #86868b;
text-align: center;
margin-top: 15px;
}
`;

const InputGroup = styled.div`
margin-bottom: 25px;

label {
display: block;
font-weight: 600;
margin-bottom: 8px;
font-size: 14px;
}

input, textarea {
width: 100%;
padding: 14px;
border: 1px solid #d2d2d7;
border-radius: 12px;
font-size: 16px;
box-sizing: border-box;
outline: none;
transition: border-color 0.2s;
font-family: inherit;

&:focus {
border-color: #0066cc;
}
}

textarea {
resize: vertical; /* 사용자가 세로 크기 조절 가능 */
}
`;

const SubmitBtn = styled.button`
width: 100%;
background: #0066cc;
color: #fff;
padding: 16px;
border: none;
border-radius: 12px;
font-size: 17px;
font-weight: 600;
cursor: pointer;
transition: background 0.2s, transform 0.1s;

&:hover {
background: #004499;
}

&:active {
transform: scale(0.99); /* 클릭 시 살짝 눌리는 효과 */
}
`;

const Footer = styled.footer`
text-align: center;
padding: 40px 0;
color: #86868b;
font-size: 12px;
`;
